/**
 * Signin Firebase
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom';
import { Form, FormGroup, Input } from 'reactstrap';
import LinearProgress from '@mui/material/LinearProgress';
import QueueAnim from 'rc-queue-anim';
import { NotificationManager } from 'react-notifications';
import CircularProgress from '@mui/material/CircularProgress';
// components
import {
   SessionSlider
} from 'Components/Widgets';

// app config
import AppConfig from 'Constants/AppConfig';

// redux action
import {
   signinUserInFirebase,
   signinUserWithFacebook,
   signinUserWithGoogle,
   signinUserWithGithub,
   signinUserWithTwitter,
   addForgotPassword,
} from 'Actions';
import withRouter from 'Util/withRouter';

//Auth File
import Auth from '../Auth/Auth';

const auth = new Auth();

class Signin extends Component {

   constructor(props) {
      super(props);
      this.state = {
         email: '',
         password: '',
         loader:false,
      }
      this.handleForgetpassword = this.handleForgetpassword.bind(this);
   }
	/**
	 * On User Login
	 */
   onUserLogin() {
      if (this.state.email !== '' && this.state.password !== '') {
         this.props.signinUserInFirebase(this.state, this.props.navigate);
      }
   }

	/**
	 * On User Sign Up
	 */
   onUserSignUp() {
      this.props.navigate('/signup/MA==');
   }

   //Auth0 Login
   loginAuth0() {
      auth.login();
   }

   handleForgetpassword(){
      this.setState({loader:true });  
      let { email } =this.state;
      if(email==''){
         NotificationManager.error('Please enter your email.');
         this.setState({loader:false });
      }else{
         this.props.addForgotPassword(email).then((data) => {   
            this.setState({loader:false });            
        });
      }
   }

   render() {
      const { email, password } = this.state;
      const { loading } = this.props;
      const styles = {
         buttonProgress: {
             color: "orange",
             position: 'absolute',
             top: '50%',
             left: '50%',
             marginTop: -15,
             marginLeft: -15,
         },
         wrapper: {
             position: 'relative',
         },
     };
      return (
         <QueueAnim type="bottom" duration={2000}>
            <div className="rct-session-wrapper">
               {loading &&
                  <LinearProgress />
               }
               <AppBar position="static" className="session-header">
                  <Toolbar>
                     <div className="container">
                        <div className="d-flex justify-content-between">
                           <div className="session-logo">
                              <Link to="/">
                                 <img src={AppConfig.appLogo} alt="session-logo" className="img-fluid" width="110" height="35" />
                              </Link>
                           </div>
                           <div>
                              <a className="mr-15" onClick={() => this.onUserSignUp()}>Create new account?</a>
                              <Button variant="contained" className="btn-light" onClick={() => this.onUserSignUp()}>Sign Up</Button>
                           </div>
                        </div>
                     </div>
                  </Toolbar>
               </AppBar>
               <div className="session-inner-wrapper">
                  <div className="container">
                     <div className="row row-eq-height">
                        <div className="col-sm-10 col-md-6 col-lg-9" style={{margin:"0 auto"}}>
                           <div className="session-body text-center">
                              <div className="session-head mb-30">
                                 <h2 className="font-weight-bold">Get started with {AppConfig.brandName}</h2>
                                 <p className="mb-0"></p>
                              </div>
                              <Form>
                                 <FormGroup className="has-wrapper">
                                    <Input
                                       type="mail"
                                       value={email}
                                       name="user-mail"
                                       id="user-mail"
                                       className="has-input input-lg signclass"
                                       placeholder="Enter Email Address"
                                       onChange={(event) => this.setState({ email: event.target.value })}
                                       style={{ backgroundColor: '#EDF0FF' }}
                                    />
                                    <span className="has-icon"><i className="ti-email"></i></span>
                                 </FormGroup>
                                 <FormGroup className="has-wrapper">
                                    <Input
                                       value={password}
                                       type="Password"
                                       name="user-pwd"
                                       id="pwd"
                                       className="has-input input-lg signclass"
                                       placeholder="Password"
                                       onChange={(event) => this.setState({ password: event.target.value })}
                                       style={{ backgroundColor: '#EDF0FF' }}
                                    />
                                    <span className="has-icon"><i className="ti-lock"></i></span>
                                 </FormGroup>
                                 <FormGroup className="mb-15">
                                    <Button
                                       color="primary"
                                       className="btn-info text-white w-100"
                                       variant="contained"
                                       size="large"
                                       onClick={() => this.onUserLogin()}
                                    >
                                       Sign In
                            			</Button>
                                 </FormGroup>  
                                 <FormGroup className="has-wrapper">
                                    <div className="float-right" style={styles.wrapper}>
                                    <button type="button" className="mr-10 mb-10 btn btn-outline-warning btn-sm" onClick={this.handleForgetpassword} disabled={this.state.loader}>Forgot Password</button> 
                                    {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}
                                    </div>
                                 </FormGroup>                              
                              </Form>                              
                           </div>
                        </div>
                       
                     </div>
                  </div>
               </div>
            </div>
         </QueueAnim>
      );
   }
}

// map state to props
const mapStateToProps = ({ authUser }) => {
   const { user, loading } = authUser;
   return { user, loading }
}

export default withRouter(connect(mapStateToProps, {
   signinUserInFirebase,
   signinUserWithFacebook,
   signinUserWithGoogle,
   signinUserWithGithub,
   signinUserWithTwitter,
   addForgotPassword
})(Signin));
